@if (showHeader()) {
	<header>
		<div class="wrapper">
			<!-- This small hack is needed for a proper headline aligning in ie11 -->
			@if (isIE) {
				<div style="height: 48px"></div>
			}
			@if (!title) {
				<ng-content select="[stagesCardTitle]"></ng-content>
			} @else {
				<span class="h5">{{ title }}</span>
			}
			<ng-content select="[switchFilter]"></ng-content>
			<ng-content select="header"></ng-content>
			<stages-toolbar [toolbarId]="toolbarId()" [items]="toolbarItems" />
			@if (showZoomToolbar && expanded) {
				<div style="flex-grow: 1"></div>
				<stages-zoom-toolbar />
			}
			@if (contentCollapsible && showCollapseOption) {
				<stages-button-expand-collapse
					class="action"
					[classes]="'menu-button'"
					[isCollapsed]="!expanded"
					(pressedButton)="toggleContentView()"
				/>
			}
			<stages-menu
				class="action"
				[menuId]="menuId()"
				iconClasses="ico ico-more-vertical"
				openTo="bottom"
				[items]="menuItems"
				[noCollapse]="menuNoCollapse"
				(click)="forceShowContent()"
			/>
		</div>
	</header>
}

<ng-content />
